// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError, AxiosResponse } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { getLabRelated } from '../../apis/lab';
import { LoadingType } from '../../types/Common';
import { LabCardType } from '../../types/Model';
import { getLabRelatedActions } from '../actionCreators/getLabRelatedActions';
import { RootAction } from '../rootActionCreator';

const outputActions = {
  success: getLabRelatedActions.success,
  failure: getLabRelatedActions.failure
};

type RequestActionTypes = ActionType<
  typeof getLabRelatedActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const getLabRelatedEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(getLabRelatedActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, loadingType = LoadingType.NEW } = action.payload;
      // send api promise
      return getLabRelated(id)
        .then((response: AxiosResponse<LabCardType[]>) => {
          // handle success case here
          return getLabRelatedActions.success({
            LabRelatedData: response.data,
            id,
            loadingType
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return getLabRelatedActions.failure({ error });
        });
    })
  );
};
